import angular from 'angular';

angular
  .module('myConsultApp')
  .directive(
    'providerSearch',
    (ProvidersService, uiGmapGoogleMapApi, $rootScope, GoogleServices) => {
      return {
        templateUrl: 'templates/v2/provider-search.html',
        restrict: 'E',
        scope: {
          onSelect: '&',
          saveTarget: '=',
          userZipCode: '=',
          preselected: '=',
        },
        link: ($scope, elem) => {
          $scope.providerMarkers = [];
          $scope.organizationResults = null;
          $scope.numberOfResults = 0;
          $scope.lastSearchProviderInput = $scope.userZipCode ? $scope.userZipCode : '';
          $scope.showResultsHeader = false;
          $scope.loadMoreButton = false;
          $scope.organizationsMeta = null;
          $rootScope.loadProviderProcess = false;
          $scope.mapMarkerNumber = 1;
          $scope.focusInput = true;
          $scope.deviceWidth = document.documentElement.clientWidth;
          $scope.scrollList = null;

          $scope.initializeMap = function () {
            uiGmapGoogleMapApi.then(function (maps) {
              if (typeof _.contains === 'undefined') {
                _.contains = _.includes;
              }
              if (typeof _.object === 'undefined') {
                _.object = _.zipObject;
              }
              $scope.map = {
                center: { latitude: 38.9372264, longitude: -92.3294106 },
                zoom: 20,
              };
              // only watch userZipCode when map is initialized
              $scope.$watch('userZipCode', () => {
                if ($scope.userZipCode) {
                  $scope.searchProviderInput = $scope.userZipCode;
                  $scope.lastsearchProviderInput = $scope.userZipCode;
                }
                GoogleServices.getCordinates(
                  $scope.userZipCode || false,
                  $scope.coordinatesCallback,
                );
              });
            });

            $scope.focusInput = true;
          };

          $scope.initializeMap();

          $scope.selectProvider = (provider) => {
            $scope.onSelect({ provider });
          };

          $scope.isSelectedProvider = function (providerId) {
            if ($scope.preselected && $scope.preselected.id) {
              return $scope.preselected.id == providerId;
            }
          };

          $scope.coordinatesCallback = function (coord) {
            if (!$scope.searchProviderInput) {
              $scope.searchProviderInput = coord.city;
              if (coord.state && !$scope.userZipCode) {
                $scope.searchProviderInput = coord.city.concat(', ', coord.state);
                $scope.lastsearchProviderInput = $scope.searchProviderInput;
              }
            }
            if ($scope.saveTarget == 'shelter') {
              var searchParm = {
                latitude: coord.latitude,
                longitude: coord.longitude,
                search: $scope.searchProviderInput,
                directory_type: 'shelter',
              };
            } else {
              var searchParm = {
                latitude: coord.latitude,
                longitude: coord.longitude,
                search: $scope.searchProviderInput,
                directory_type: 'clinic',
              };
            }

            $.each(searchParm, function (key, value) {
              if (!value) {
                delete searchParm[key];
              }
            });

            $scope.showProvidersOnMap(searchParm);
          };

          $scope.submitSearchProvider = function (searchProviderInput) {
            $scope.providersLoading = true;
            $scope.hideWhileLoading = true;
            $scope.mapMarkerNumber = 1;
            $scope.searchProviderInput = searchProviderInput;
            $scope.lastsearchProviderInput = searchProviderInput;
            GoogleServices.getCordinates(searchProviderInput, $scope.coordinatesCallback);
          };

          $scope.scrollMonitor = () => {
            $scope.scrollList.scroll((event) => {
              const scroll = $scope.scrollList.scrollTop();
              const scrollHeight =
                elem.find('.organization').outerHeight() * (elem.find('.organization').length - 10);
              if ($scope.loadMoreButton && scroll >= scrollHeight) {
                $scope.loadMoreProviders();
              }
            });
          };

          $scope.showProvidersOnMap = async (paramObj) => {
            await ProvidersService.searchProviders(paramObj).then(function (response) {
              $scope.returnMarkers = [];
              $scope.numberOfResults = response.meta.count;
              $rootScope.loadProviderProcess = false;
              $scope.mapMarkerNumber = 1;
              angular.forEach(response.organizations, function (value, key) {
                var lon = value.longitude;
                var lat = value.latitude;

                if (lat != 0 && lat != null && lon != 0 && lon != null) {
                  value.count = $scope.mapMarkerNumber;
                  var preparedMarker = GoogleServices.prepareMapMarker(value);
                  $scope.mapMarkerNumber++;
                  $scope.returnMarkers.push(preparedMarker);
                }
              });

              $scope.providerMarkers = $scope.returnMarkers;
              $scope.organizationResults = response.organizations;
              $scope.showResultsHeader = true;
              $scope.organizationsMeta = response.meta;
              $scope.providersLoading = false;
              $scope.hideWhileLoading = false;
              if ($scope.numberOfResults > 10) {
                $scope.loadMoreButton = true;
              } else {
                $scope.loadMoreButton = false;
              }
            });
            if ($scope.loadMoreButton) {
              $scope.scrollList = $(elem).find('.results-scroll');
              $scope.scrollMonitor();
            }
          };

          $scope.loadMoreProviders = function () {
            if ($scope.loadMoreButton && !$rootScope.loadProviderProcess) {
              $scope.providersLoading = true;
              ProvidersService.getProviderPage($scope.organizationsMeta.next).then(function (
                response,
              ) {
                $scope.returnMarkers = [];
                angular.forEach(response.organizations, function (value, key) {
                  var lon = value.longitude;
                  var lat = value.latitude;
                  if (lat != 0 && lat != null && lon != 0 && lon != null) {
                    value.count = $scope.mapMarkerNumber;
                    var preparedMarker = GoogleServices.prepareMapMarker(value);
                    $scope.mapMarkerNumber++;
                    $scope.returnMarkers.push(preparedMarker);
                    $scope.providerMarkers.push(preparedMarker);
                  }
                  $scope.organizationResults.push(value);
                });
                $scope.organizationsMeta = response.meta;
                $scope.providersLoading = false;
                if (response.meta.next != null) {
                  $scope.loadMoreButton = true;
                } else {
                  $scope.loadMoreButton = false;
                }
                $rootScope.loadProviderProcess = false;
              });
            }
          };

          $scope.panToMarker = function (marker) {
            if (marker.latitude != 0 && marker.longitude != 0) {
              $scope.map = {
                center: { latitude: marker.latitude, longitude: marker.longitude },
                zoom: 20,
              };
            }
          };
          $scope.providersLoading = true;
          $scope.hideWhileLoading = true;
        },
      };
    },
  );
